export const mailReportMail = (surveyName?: string) =>
  `Bijgevoegd vind je jouw rapportage van de reflector ${
    surveyName ?? "{survey.name}"
  }. Heb je feedbackgevers uitgenodigd en zie je ze niet in de rapportage, dan
   hebben zij de reflector nog niet afgerond. Bekijk hun voortgang bij 'home'
   in de app en download de rapportages opnieuw als ze klaar zijn.
`;
